import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { AiFilterChip } from '~/components/AiSearchChips/AiFilterChip/AiFilterChip';
import { ChipConnector } from '~/components/AiSearchChips/ChipConnector/ChipConnector';
import { FilterChip } from '~/components/AiSearchChips/FilterChip/FilterChip';
import { currentValue, nextPredicate } from '~/components/AiSearchChips/StringMatchChip/StringMatchChip.utils';
import { useLocaleKeys } from '~/i18n';
import { useSettingsChipTone } from '~/pages/DraftsDashboard/DraftsAiSearch/DraftsAiSearchChips/settingsChipTone';
import { moveCollectionQuantifier, nextCollectionQuantifier, presentCollectionEntries, setCollectionQuantifier } from './collection-predicate';
import { isSingleNameCollection, pureOrNamePills, removeOrArm } from './CollectionChips.utils';
import { CollectionConditionChip } from './CollectionConditionChip/CollectionConditionChip';
import { collectionOperatorLabel } from './CollectionConditionChip/CollectionConditionChip.utils';
export const GetCollectionChipsTID = (parentTestId)=>getTestIds(parentTestId);
export const CollectionChips = (param)=>{
    let { testId, fieldLabel, nounLabel, collection, toggleBiName, removeBiName, biPrefix, onChange } = param;
    const { CollectionChipsTestIds } = useMemo(()=>GetCollectionChipsTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const tone = useSettingsChipTone();
    const toggleQuantifier = (quantifier)=>{
        const target = nextCollectionQuantifier(collection, quantifier);
        if (target === quantifier) return;
        onChange(moveCollectionQuantifier(collection, quantifier, target));
    };
    const renderQuantifier = (quantifier, predicate)=>{
        const orPills = pureOrNamePills(predicate);
        if (orPills == null) {
            if (isSingleNameCollection(predicate) && predicate.name != null) {
                const name = predicate.name;
                return /*#__PURE__*/ _jsx(AiFilterChip, {
                    mode: "text",
                    testId: CollectionChipsTestIds.Chip(quantifier),
                    fieldLabel: fieldLabel,
                    value: currentValue(name),
                    operator: {
                        label: collectionOperatorLabel(quantifier, t),
                        onToggle: ()=>toggleQuantifier(quantifier),
                        biName: toggleBiName
                    },
                    tone: tone,
                    onApply: (value)=>onChange(setCollectionQuantifier(collection, quantifier, value === '' ? undefined : _object_spread_props(_object_spread({}, predicate), {
                            name: nextPredicate(value, name)
                        }))),
                    onRemove: ()=>onChange(setCollectionQuantifier(collection, quantifier, undefined)),
                    biPrefix: biPrefix,
                    texts: {
                        apply: t.applyButton()
                    }
                });
            }
            return /*#__PURE__*/ _jsx(CollectionConditionChip, {
                testId: CollectionChipsTestIds.Chip(quantifier),
                fieldLabel: fieldLabel,
                nounLabel: nounLabel,
                quantifier: quantifier,
                predicate: predicate,
                toggleBiName: toggleBiName,
                removeBiName: removeBiName,
                onToggleQuantifier: ()=>toggleQuantifier(quantifier),
                onRemove: ()=>onChange(setCollectionQuantifier(collection, quantifier, undefined))
            });
        }
        return orPills.map((pill, pillIndex)=>/*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    pillIndex > 0 && /*#__PURE__*/ _jsx(ChipConnector, {
                        testId: CollectionChipsTestIds.OrPillConnector(quantifier, pill.armIndex),
                        tone: "or"
                    }),
                    /*#__PURE__*/ _jsx(FilterChip, {
                        testId: CollectionChipsTestIds.OrPill(quantifier, pill.armIndex),
                        fieldLabel: fieldLabel,
                        operator: {
                            label: collectionOperatorLabel(quantifier, t),
                            onToggle: ()=>toggleQuantifier(quantifier),
                            biName: toggleBiName
                        },
                        valueLabel: pill.valueLabel,
                        onRemove: ()=>onChange(removeOrArm(collection, quantifier, predicate, pill.armIndex)),
                        removeBiName: removeBiName,
                        tone: tone
                    })
                ]
            }, pill.armIndex));
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: presentCollectionEntries(collection).map((param, index)=>{
            let { quantifier, predicate } = param;
            return /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ _jsx(ChipConnector, {
                        testId: CollectionChipsTestIds.AndConnector(index - 1),
                        tone: "and"
                    }),
                    renderQuantifier(quantifier, predicate)
                ]
            }, quantifier);
        })
    });
};
